module.exports = __webpack_public_path__ + "img/cg.e138950f.png";